/* Five independent questions rather than five steps, so they are not numbered.
   Written as questions because that is what a gate is. */
const checks = [
  ['Live pose', 'Can it say where it is and which way it faces?'],
  ['Runtime keep-out', 'Will it accept a zone that appears mid-shift?'],
  ['Hold & release', 'Can we stop one named vehicle and start it again?'],
  ['Map export', 'Does its map come out in a frame we can share?'],
  ['Command latency', 'How long from our command to its wheels? Measured on site.'],
] as const;

export function Compatibility() {
  return (
    <section className="sec sec--dark" id="compatibility">
      <div className="sec__label">Compatibility gate</div>
      <h2 className="big drift">Five checks<br />set the ceiling.</h2>

      <div className="check-line">
        {checks.map(([title, detail]) => (
          <div className="check reveal" key={title}>
            <b>{title}</b><small>{detail}</small>
          </div>
        ))}
      </div>
      <p className="visual-caption reveal">
        A low score sets which level the fleet runs at. It does not keep the fleet off the floor.
      </p>
    </section>
  );
}
